import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { unstable_useMediaQuery as useMediaQuery } from "@material-ui/core/useMediaQuery";
import { formatApiDateTime } from "../../tools/formatApiDateTime";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import { withStyles, withTheme } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import { Tooltip } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import withContext from "../../tools/withContext";
import BatchActionButton from "./components/BatchActionButton";
import BatchesActionButton from "./components/BatchesActionButton";
import ProgressBar from "./components/ProgressBar";
import BatchSearchBar from "./components/BatchSearchBar";
import UiSelect from "../common/UiSelect";
import TableBody from "../common/TableBody";
import EnhancedTableHeader from "../common/EnhancedTableHeader";
import DimensionsContainer from "../common/DimensionsContainer";
import TableNavigation from "../common/TableNavigation";
import { stableSort, getSorting } from "../../tools/sortingTools";
import BatchType from "../../types/Batch";
import ContextType from "../../types/Context";
import UserType from "../../types/User";
import { getHistory, pushToHistory } from "../../tools/batchHistory";
import useRouter from "../../tools/useRouter";
import t from "../../locales/t";
import FilteringBatchesDialog, { BATCH_STATUS } from "./components/FilteringBatchesDialog";
import BatchFilterChips from "./components/BatchFilterChips";
import { tablePageStyles, tablePageRootStyles, tablePageToolbarStyles } from "../common/tableTheme";

const rowsPerPageOptions = [20, 50, 100];

const styles = (theme: Theme) =>
  createStyles({
    root: {
      ...tablePageRootStyles(theme),
    },
    ...tablePageStyles(theme),
    ...tablePageToolbarStyles(theme),
    noData: {
      textAlign: "center",
      padding: theme.spacing.unit * 12,
      color: theme.palette.text.secondary,
    },
    fullWidth: {
      width: "100%",
    },
  });


const StatusIcon = ({ state }: any) => {
  //@ts-ignore
  const { label, color, icon: Icon } = BATCH_STATUS[state]

  return (
    <Chip
      icon={<Icon style={{ color, marginLeft: "4px", marginRight: "-10px" }} />}
      label={t(label)}
      variant="outlined"
      style={{
        color,
        borderColor: color,
        height: "28px",
        width: "85%"
      }}
    />
  )
}
interface PropsType {
  classes: any;
  ctx: ContextType;
  batches: BatchType[];
  saveBatch: Function;
  massUpdate: Function;
  deleteBatch: Function;
  deleteDeadline: Function;
  applyLabeling: Function;
  users: UserType[];
  isLoading: boolean;
  theme: any;
  location: any;
  history: any;
  match: any;
  pagination: any;
  keyEvent: any;
}

const Batches = (props: PropsType) => {
  const {
    classes,
    ctx: { user, appFetch },
    match: {
      params: { noPage },
    },
    location: { search },
    batches,
    massUpdate,
    saveBatch,
    deleteBatch,
    deleteDeadline,
    applyLabeling,
    users,
    isLoading,
    theme,
    pagination,
    keyEvent,
  } = props;

  const router = useRouter();
  const urlParams = router.query;

  const handleBatchStateFilterSubmitted = (filter: string | null) => {
    const { batchState, ...rest } = urlParams;
    const newQuery = {
      ...rest,
      ...(filter ? { batchState: filter } : {}),
    };
    props.history.push(`/batches/0?${queryString.stringify(newQuery)}`);
  };

  const columns = [
    {
      id: "selection",
      numeric: false,
      sortable: false,
      filter: false,
      clickable: true,
      disablePadding: false,
      label: "",
      onlyRoles: ["ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      size: 0.5,
      align: "left",
    },
    {
      id: "name",
      numeric: false,
      sortable: true,
      filter: false,
      truncate: true,
      disablePadding: true,
      label: "Nom du lot",
      onlyRoles: null,
      size: 2,
      align: "left",
    },
    {
      id: "createdDate",
      numeric: false,
      sortable: true,
      filter: false,
      disablePadding: false,
      label: "Date de création",
      onlyRoles: ["ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      size: 2,
      align: "center",
    },
    {
      id: "filterFields.projectName",
      filterId: "filterFields.lowerProjectName",
      numeric: false,
      sortable: true,
      filter: false,
      truncate: true,
      disablePadding: false,
      label: "Projet",
      onlyRoles: null,
      size: 1.2,
      align: "left",
    },
    {
      id: "filterFields.percentDone",
      numeric: true,
      sortable: true,
      filter: false,
      disablePadding: false,
      label: "Etat d'avancement",
      onlyRoles: null,
      size: 2,
      align: "center",
    },
    {
      id: "state",
      numeric: true,
      sortable: false,
      filter: true,
      filterActive: typeof urlParams.batchState !== "undefined",
      filterComponent: ({ open, onClose }: { open: boolean; onClose: any }) => (
        <FilteringBatchesDialog
          open={open}
          onClose={onClose}
          onSubmit={handleBatchStateFilterSubmitted}
          batchState={urlParams.batchState}
        />
      ),
      disablePadding: false,
      label: "Statut",
      onlyRoles: null,
      size: 1.5,
      align: "center",
    },
    {
      id: "labeler.firstName",
      filterId: "filterFields.labelerFirstName",
      numeric: false,
      sortable: true,
      filter: false,
      disablePadding: false,
      label: "Labeler",
      onlyRoles: ["ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      size: 1,
      align: "left",
    },
    {
      id: "deadline",
      numeric: false,
      sortable: true,
      filter: false,
      disablePadding: false,
      label: "Date limite",
      onlyRoles: null,
      size: 1,
      align: "left",
    },
    {
      id: "actions",
      numeric: false,
      sortable: false,
      filter: false,
      disablePadding: false,
      label: "Actions",
      onlyRoles: null,
      size: 1.5,
      align: "right",
    },
  ];

  // FILTERS /////////////////////////////////////
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdDate");
  const [rowsPerPage, setRowsPerPage] = useState<number>(rowsPerPageOptions[0]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [scope, setScope] = useState<"history" | "all" | "my">("all");
  //////////////////////////////////////////////////

  useEffect(() => {
    if (urlParams.sort && typeof urlParams.sort === "string") {
      setOrderBy(urlParams.sort.split(",")[0]);
      setOrder(urlParams.sort.split(",")[1]);
    } else {
      setOrderBy("createdDate");
      setOrder("desc");
    }
    if (urlParams.size && typeof urlParams.size === "string") {
      setRowsPerPage(Number(urlParams.size));
    } else {
      setRowsPerPage(rowsPerPageOptions[0]);
    }
    if (urlParams.searchTerm && typeof urlParams.searchTerm === "string") {
      setSearchTerm(urlParams.searchTerm);
    } else {
      setSearchTerm("");
    }

    setScope(urlParams.batchIds ? "history" : urlParams.userId ? "my" : "all");

  }, [search, urlParams]);

  const [selected, setSelected] = useState<number[]>([]);
  const [modalMode, setModalMode] = useState<boolean>(false);
  const [childrenShiftKeyPressed, setChildrenShiftKeyPressed] = useState<boolean>(false);

  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  function deleteDuplicates(array: number[]): number[] {
    return array.filter((array, index, self) => {
      return self.indexOf(array) === index;
    });
  }

  const handleRequestSort = (event: any, property: string) => {
    let _orderBy = property;
    let _order = "desc";

    if (orderBy === property && order === "desc") {
      _order = "asc";
    }

    props.history.push(
      `/batches/${noPage}?${queryString.stringify(
        { ...urlParams, sort: `${_orderBy},${_order}` },
        { strict: false }
      )}`
    );
    setOrderBy(_orderBy);
    setOrder(_order);
  };

  const handleSelectAllClick = (event: any) => {
    const currentPageIds = batches.map((n) => n.id);
    if (event.target.checked) {
      setSelected(
        deleteDuplicates([...selected, ...currentPageIds])
      );
      return;
    }
    setSelected(selected.filter((id) => !currentPageIds.includes(id)));
  };

  const handleSelection = (event: any, batchSelectedId: any) => {
    if (modalMode) return;
    const shiftKey = keyEvent.shiftKey || childrenShiftKeyPressed;
    const selectedIndex = selected.indexOf(batchSelectedId);
    let newSelected: number[] = [];
    if (selectedIndex === -1 || shiftKey) {
      if (!shiftKey) {
        newSelected = newSelected.concat(selected, batchSelectedId);
      } else if (selected.length === 1) {
        const firstElIdx = batches.findIndex(
          (b: BatchType) => b.id === selected[0]
        );
        const newSelectedIdx = batches.findIndex(
          (b: BatchType) => b.id === batchSelectedId
        );
        newSelected =
          firstElIdx < newSelectedIdx
            ? batches
              .slice(firstElIdx, newSelectedIdx + 1)
              .map((b: BatchType) => b.id)
            : batches
              .slice(newSelectedIdx, firstElIdx + 1)
              .map((b: BatchType) => b.id);
      }
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handlePushToHistory = (id: number) => {
    //@ts-ignore
    pushToHistory(id, user.id);
  };

  const selectOne = (id: any) => {
    setSelected([id]);
  };

  const selectNone = (id: any) => {
    setSelected([]);
  };

  const isAdmin =
    user &&
    (user.authorities[0] === "ROLE_ADMIN" ||
      user.authorities[0] === "ROLE_PROJECT_ADMIN");

  const isLabeler = user?.authorities[0] === "ROLE_LABELER";

  const roleFilter = (column: any) =>
    column.onlyRoles === null ||
    //@ts-ignore
    column.onlyRoles.includes(user.authorities[0]);

  const batchesOrdereFiltered =
    order !== "createdDate"
      ? stableSort(batches, getSorting(order, orderBy))
      : batches;

  const getLabelerFirstName = (b: BatchType) => {
    if (b.labeler && b.labeler.firstName) {
      return b.labeler.firstName;
    }
    return "";
  };

  const getProjectLabelingType = (b: BatchType) => {
    if (
      b.project &&
      b.project.labelingTypes &&
      b.project.labelingTypes[0] &&
      b.project.labelingTypes[0].name
    ) {
      return b.project.labelingTypes[0].name;
    }
    return "";
  };

  const buildColumns = (b: BatchType, isSelected: boolean) => {
    const projectLabelingType = getProjectLabelingType(b);
    const cols = [

      // CHECKBOX
      <div>
        <Checkbox checked={isSelected} classes={{ root: classes.modernCheckbox }} />
      </div>
      ,

      // NAME      
      <Tooltip title={
        <Typography variant="body1" style={{ color: "white", textTransform: "capitalize" }}>{b.name}</Typography>
      } placement="top-start">
        <div>{b.name}</div>
      </Tooltip>
      ,

      // DATE
      <div>
        {formatApiDateTime(b.createdDate)}
      </div>
      ,

      // PROJECT NAME
      <Tooltip title={
        <Typography variant="body1" style={{ color: "white", textTransform: "capitalize" }}>
          {b.filterFields.projectName}
          {projectLabelingType ? ` (${projectLabelingType})` : ""}
        </Typography>
      } placement="top-start">
        <div>
          {b.filterFields.projectName}
          {projectLabelingType && (
            <>
              <br />
              <small style={{ color: "gray", fontSize: "10px" }}>{projectLabelingType}</small>
            </>
          )}
        </div>
      </Tooltip>
      ,

      // PROGRESS
      <div>
        <ProgressBar
          totalLabelDocs={b.totalLabelDocs}
          totalEligibleDocs={b.totalEligibleDocs}
          totalLabelDocsByModel={b.totalLabelDocsByModel}
          isVideo={projectLabelingType === "VIDEO"}
        />
      </div>
      ,

      // STATUS
      <div>
        <StatusIcon state={b.state} />
      </div>
      ,

      // LABELER NAME
      <div style={{ textTransform: "capitalize" }}>{getLabelerFirstName(b)}</div>
      ,

      // DEADLINE
      <div>
        {b.deadline
          ? formatApiDateTime(b.deadline, "DD/MM/YY")
          : "Aucune"}
      </div>
      ,

      // ACTIONS
      <div>
        <BatchActionButton
          batches={batches}
          users={users}
          batch={b}
          selected={selected}
          massUpdate={massUpdate}
          saveBatch={saveBatch}
          selectOne={() => selectOne(b.id)}
          deleteBatch={deleteBatch}
          deleteDeadline={deleteDeadline}
          applyLabeling={applyLabeling}
          isAdmin={isAdmin}
          pushToHistory={handlePushToHistory}
          setModalMode={setModalMode}
          variant="modern"
        />
      </div>
      ,
    ];
    // @ts-ignore
    return cols.filter((_: any, idx: number) => roleFilter(columns[idx]));
  };

  const handleChangePage = (noP: any) => {
    props.history.push(
      `/batches/${noP}?${queryString.stringify(router.query)}`
    );
  };

  const handleChangeRowsPerPage = (perPage: any) => {
    props.history.push(`/batches/0?${queryString.stringify({
      ...router.query,
      size: perPage,
    })}`);
  };

  const handleSearch = (str: string) => {
    const trimmed = str.trim();
    props.history.push(
      `/batches/0?${queryString.stringify(
        {
          ...router.query,
          batchSearchMode: undefined,
          labels: undefined,
          searchTerm: trimmed.length > 0 ? trimmed : undefined,
        },
        { arrayFormat: "none" }
      )}`
    );
  };

  const handleChangeScope = (e: any) => {    
    switch (e.target.value) {
      case "history":
        props.history.push(
          //@ts-ignore
          `/batches/0?batchIds=${getHistory(user.id).join(",")}&size=${rowsPerPage}&sort=createdDate,desc`
        );
        break;
      case "my":
        props.history.push(    
          `/batches/0?userId=${user.id}&size=${rowsPerPage}&sort=createdDate,desc`          
        );
        break;
      case "all":        
      default:
        props.history.push(`/batches/0?size=${rowsPerPage}&sort=createdDate,desc`);
        break;
    }
  };

  const handleChildrenKeyEvent = (state: boolean) =>
    setChildrenShiftKeyPressed(state);

  return (
    <Grid container direction="column" className={classes.root}>
      <Helmet>
        <title>Liste des lots</title>
      </Helmet>
      <Grid item className={classes.fullWidth}>
        <div className={classes.pageToolbar}>
          <div className={classes.pageToolbarLeft}>
            <div className={classes.pageTitleRow}>
              <Typography
                component="h2"
                className={classNames(classes.pageTitle, {
                  [classes.pageTitleCompact]: matches,
                })}
              >
                Liste des lots
              </Typography>
              {!urlParams.projectId && (
                <div className={classes.scopeSelectWrap}>
                  <UiSelect
                    name="scope"
                    value={scope}
                    onChange={handleChangeScope}
                    variant="modern"
                    className={classes.scopeSelect}
                  >
                    <option value="all">Tous les lots</option>
                    {!isLabeler && <option value="my">Tous mes lots</option>}
                    {typeof user !== "undefined" &&
                      getHistory(user.id).length > 0 && (
                        <option value="history">Derniers lots consultés</option>
                      )}
                  </UiSelect>
                </div>
              )}
            </div>
          </div>
          <div className={classes.pageToolbarRight}>
            <div className={classes.pageLoaderSlot}>
              {isLoading && (
                <CircularProgress
                  color="secondary"
                  size={20}
                  className={classes.pageLoader}
                />
              )}
            </div>
            {isAdmin && (
              <BatchesActionButton
                variant="modern"
                saveBatch={massUpdate}
                deleteBatch={deleteBatch}
                users={users}
                batches={batches}
                selected={selected}
                selectNone={selectNone}
                setModalMode={setModalMode}
              />
            )}
            <BatchSearchBar
              searchTerm={searchTerm}
              onSearch={handleSearch}
            />
          </div>
        </div>
        <BatchFilterChips
          urlParams={urlParams}
          batches={batches}
          searchTerm={searchTerm}
          userId={user?.id}
          history={props.history}
          appFetch={appFetch}          
        />
      </Grid>
      <>
        <Grid item className={classes.tableWrapper}>
          <Paper elevation={0} className={classes.tableCard}>
            <EnhancedTableHeader
              variant="modern"
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
              rowCount={batches.length}
              columns={columns.filter(roleFilter)}
              withCheckBox={isAdmin}
              numSelected={
                selected.filter((nombre) =>
                  batches.map((b) => b.id).includes(nombre)
                ).length
              }
              numSelectedTotal={selected.length}
            />
            {batchesOrdereFiltered.length === 0 && !isLoading && (
              <Typography className={classes.tableEmptyInCard} variant="h6">
                Aucun lot{" "}
                {isAdmin &&
                  searchTerm !== "" &&
                  " ne correspond à votre recherche"}
                {!isAdmin && " ne vous a été attribué."}
              </Typography>
            )}
            {batchesOrdereFiltered.length > 0 && (
              <div className={classes.tableScrollArea}>
                <DimensionsContainer variant="modern">
                  <TableBody
                    variant="modern"
                    handleSelection={handleSelection}
                    selected={selected}
                    buildColumns={buildColumns}
                    datas={batchesOrdereFiltered}
                    noPage={noPage}
                    columns={columns.filter(roleFilter)}
                    onShiftStateChanged={handleChildrenKeyEvent}
                  />
                </DimensionsContainer>
              </div>
            )}
            {!isLoading && pagination && pagination.totalElements > 0 && (
              <TableNavigation
                variant="modern"
                rowsPerPageOptions={rowsPerPageOptions}
                pagination={pagination}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangePerPage={handleChangeRowsPerPage}
                itemName="Lots"
                numberSelected={selected.length}
              />
            )}
          </Paper>
        </Grid>
      </>
    </Grid>
  );
};

export default withStyles(styles)(
  withRouter(withContext(withTheme()(Batches)))
);
